import { EventStreamCodec } from "@aws-sdk/eventstream-codec";
var EventStreamMarshaller = (function () {
    function EventStreamMarshaller(toUtf8, fromUtf8) {
        this.codec = new EventStreamCodec(toUtf8, fromUtf8);
    }
    EventStreamMarshaller.prototype.marshall = function (message) {
        return this.codec.encode(message);
    };
    EventStreamMarshaller.prototype.unmarshall = function (message) {
        return this.codec.decode(message);
    };
    EventStreamMarshaller.prototype.formatHeaders = function (rawHeaders) {
        return this.codec.formatHeaders(rawHeaders);
    };
    return EventStreamMarshaller;
}());
export { EventStreamMarshaller };
